if (!customElements.get('cro-cart-progress')) {
  class CroCartProgress extends HTMLElement {
    connectedCallback() {
      this.message = this.querySelector('[data-cro-progress-message]');
      this.shippingMessage = this.querySelector('[data-cro-shipping-message]');
      this.bar = this.querySelector('[data-cro-progress-value]');
      this.count = this.querySelector('[data-cro-current-count]');
      this.shippingThreshold = Number(this.dataset.shippingThreshold || 29900);
      this.currency = this.dataset.currency || 'INR';
      this.locale = this.dataset.locale || 'en-IN';
      this.update(Number(this.dataset.cartCount || 0), Number(this.dataset.cartTotal || 0));

      this.onCartUpdated = this.onCartUpdated.bind(this);
      document.addEventListener('cart:updated', this.onCartUpdated);

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          const quantity = Number(event?.cartData?.item_count ?? event?.cart?.item_count);
          const total = Number(event?.cartData?.total_price ?? event?.cart?.total_price);
          if (Number.isFinite(quantity) && quantity >= 0 && Number.isFinite(total) && total >= 0) {
            this.update(quantity, total);
          } else {
            this.refresh();
          }
        });
      }
    }

    disconnectedCallback() {
      document.removeEventListener('cart:updated', this.onCartUpdated);
      if (typeof this.unsubscribe === 'function') this.unsubscribe();
    }

    onCartUpdated(event) {
      const quantity = Number(event?.detail?.cart?.item_count ?? event?.detail?.item_count);
      const total = Number(event?.detail?.cart?.total_price ?? event?.detail?.total_price);
      if (Number.isFinite(quantity) && quantity >= 0 && Number.isFinite(total) && total >= 0) {
        this.update(quantity, total);
      } else {
        this.refresh();
      }
    }

    async refresh() {
      try {
        const cartUrl = (window.routes?.cart_url || '/cart') + '.js';
        const response = await fetch(cartUrl, { headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        const cart = await response.json();
        this.update(Number(cart.item_count || 0), Number(cart.total_price || 0));
      } catch (error) {
        // Keep the server-rendered tracker when the cart endpoint is unavailable.
      }
    }

    formatMoney(cents) {
      return new Intl.NumberFormat(this.locale, {
        style: 'currency',
        currency: this.currency,
        maximumFractionDigits: 0
      }).format(cents / 100);
    }

    update(quantity, total) {
      this.dataset.cartCount = String(quantity);
      this.dataset.cartTotal = String(total);
      this.hidden = quantity <= 0;

      let message = '';
      if (quantity < 3) {
        const remaining = 3 - quantity;
        message = 'Add ' + remaining + ' more to unlock 10% OFF';
      } else if (quantity < 5) {
        message = '10% OFF unlocked · Add ' + (5 - quantity) + ' more for 15%';
      } else if (quantity < 8) {
        message = '15% OFF unlocked · Add ' + (8 - quantity) + ' more for 20%';
      } else {
        message = 'Best offer unlocked · 20% OFF';
      }

      if (this.message) this.message.textContent = message;
      if (this.shippingMessage) {
        const shippingRemaining = Math.max(this.shippingThreshold - total, 0);
        this.shippingMessage.textContent = shippingRemaining === 0
          ? 'FREE shipping unlocked'
          : 'Add ' + this.formatMoney(shippingRemaining) + ' for FREE shipping';
      }
      if (this.count) this.count.textContent = String(quantity);
      if (this.bar) this.bar.style.width = Math.min((quantity / 8) * 100, 100) + '%';

      this.querySelectorAll('[data-tier]').forEach((tier) => {
        tier.classList.toggle('is-active', quantity >= Number(tier.dataset.tier));
      });
      this.querySelectorAll('[data-tier-dot]').forEach((dot) => {
        dot.classList.toggle('is-active', quantity >= Number(dot.dataset.tierDot));
      });
    }
  }

  customElements.define('cro-cart-progress', CroCartProgress);
}
